"use client";

import Link from "next/link";
import type { Agreements } from "@/lib/types";
import { Checkbox } from "./ui/Choice";

const ITEMS: { key: keyof Agreements; label: string; required: boolean; href?: string; note?: string }[] = [
  { key: "terms", label: "이용약관 동의", required: true, href: "/terms" },
  { key: "privacy", label: "개인정보 수집·이용 동의", required: true, href: "/privacy" },
  {
    key: "creditPolicy",
    label: "크레딧 이용 정책 동의",
    required: true,
    href: "/terms#credit",
    note: "AI 기능 사용 중 크레딧 잔액이 마이너스가 될 수 있으며, 마이너스 금액은 다음 달 제공 크레딧에서 먼저 차감됩니다.",
  },
  { key: "marketing", label: "신규 공고·혜택 소식 받기", required: false },
];

export const EMPTY_AGREEMENTS: Agreements = { terms: false, privacy: false, creditPolicy: false, marketing: false };

export function requiredAgreed(a: Agreements) {
  return a.terms && a.privacy && a.creditPolicy;
}

export function AgreementList({ value, onChange }: { value: Agreements; onChange: (v: Agreements) => void }) {
  const all = ITEMS.every((i) => value[i.key]);
  return (
    <div className="rounded-md border border-gray-400 bg-white">
      <div className="border-b border-gray-400 px-4 py-3.5">
        <Checkbox
          checked={all}
          onChange={(v) => onChange({ terms: v, privacy: v, creditPolicy: v, marketing: v })}
        >
          <span className="font-semibold text-gray-900">전체 동의</span>
        </Checkbox>
      </div>
      <ul className="flex flex-col gap-3 px-4 py-4">
        {ITEMS.map((i) => (
          <li key={i.key} className="flex flex-col gap-1">
            <div className="flex items-start justify-between gap-2">
              <Checkbox checked={value[i.key]} onChange={(v) => onChange({ ...value, [i.key]: v })}>
                <span className={i.required ? "text-primary-900" : "text-gray-500"}>
                  [{i.required ? "필수" : "선택"}]
                </span>{" "}
                {i.label}
              </Checkbox>
              {i.href && (
                <Link href={i.href} target="_blank" className="shrink-0 text-xs text-gray-500 underline underline-offset-2">
                  보기
                </Link>
              )}
            </div>
            {i.note && <p className="pl-8 text-xs text-gray-600">{i.note}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
}
